import { Helmet } from "react-helmet-async";
import { ShieldX, Mail } from "lucide-react";

const BlockedPage = () => {
  return (
    <>
      <Helmet>
        <title>Access Denied - Golden Stream</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="max-w-md w-full text-center space-y-6">
          {/* Icon */}
          <div className="mx-auto w-24 h-24 rounded-full bg-destructive/20 flex items-center justify-center">
            <ShieldX className="w-12 h-12 text-destructive" />
          </div>

          {/* Title */}
          <div className="space-y-2">
            <h1 className="text-3xl font-bold text-foreground">
              Access Blocked
            </h1>
            <p className="text-lg text-muted-foreground">
              Your IP address has been blocked from accessing this site.
            </p>
          </div>

          {/* Message Box */}
          <div className="bg-card border border-border rounded-lg p-6 space-y-4">
            <p className="text-sm text-muted-foreground">
              This block may have been applied due to suspicious activity, 
              violation of our terms of service, or security concerns.
            </p>
            
            <div className="pt-4 border-t border-border">
              <p className="text-sm text-muted-foreground mb-3">
                If you believe this is a mistake, please contact our support team:
              </p>
              <a 
                href="mailto:support@goldenstream.tv"
                className="inline-flex items-center gap-2 text-primary hover:underline font-medium"
              >
                <Mail className="w-4 h-4" />
                support@goldenstream.tv
              </a>
            </div>
          </div>

          {/* Footer */}
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Golden Stream. All rights reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default BlockedPage;
